import { render, staticRenderFns } from "./BudgetModal.vue?vue&type=template&id=e953588e&"
import script from "./BudgetModal.vue?vue&type=script&lang=js&"
export * from "./BudgetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports